import { useState } from 'react';

import ApartmentIcon from '@mui/icons-material/Apartment';
import ArticleIcon from '@mui/icons-material/Article';
import DashboardIcon from '@mui/icons-material/SpaceDashboard';
import DevicesIcon from '@mui/icons-material/DevicesOther';
import KeyIcon from '@mui/icons-material/VpnKeyOutlined';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { NavLink, Outlet } from 'react-router-dom';

import { BackofficeTokenDialog } from '@/layout/BackofficeTokenDialog';

const DRAWER_WIDTH = 260;

const NAV_ITEMS = [
    { to: '/dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
    { to: '/organizations', label: 'Organizations', icon: <ApartmentIcon /> },
    { to: '/agents', label: 'Hospitals agents', icon: <DevicesIcon /> },
    { to: '/protocols', label: 'Protocols', icon: <ArticleIcon /> },
];

interface AppLayoutProps {
    onLogout?: () => void;
}

export function AppLayout({ onLogout }: AppLayoutProps) {
    const [tokenDialogOpen, setTokenDialogOpen] = useState(false);

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
                        BYO Health Backoffice
                    </Typography>
                    <Tooltip title="Set backoffice token">
                        <IconButton color="inherit" onClick={() => setTokenDialogOpen(true)}>
                            <KeyIcon />
                        </IconButton>
                    </Tooltip>
                </Toolbar>
            </AppBar>

            <Drawer
                variant="permanent"
                sx={{
                    width: DRAWER_WIDTH,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: DRAWER_WIDTH, boxSizing: 'border-box' },
                }}
            >
                <Toolbar />
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        {NAV_ITEMS.map((item) => (
                            <ListItemButton
                                key={item.to}
                                component={NavLink}
                                to={item.to}
                                sx={{
                                    '&.active': {
                                        backgroundColor: 'action.selected',
                                        borderRight: 3,
                                        borderColor: 'primary.main',
                                    },
                                }}
                            >
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.label} />
                            </ListItemButton>
                        ))}
                    </List>
                    <Divider />
                </Box>
            </Drawer>

            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />
                <Outlet />
            </Box>

            <BackofficeTokenDialog
                open={tokenDialogOpen}
                onClose={() => setTokenDialogOpen(false)}
                onDisconnected={onLogout}
            />
        </Box>
    );
}
